module.exports = __webpack_public_path__ + "static/img/chery_9@2x.99198de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_9@2x.png
// module id = aQjL
// module chunks = 0